import React from 'react';
import { Link } from 'react-router-dom';

const BASE_URL = 'https://spamsandbox.com';

export default function Breadcrumb({ items = [] }) {
  if (!items.length) return null;

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      ...(item.to ? { item: `${BASE_URL}${item.to}` } : {}),
    })),
  };

  return (
    <>
      <nav aria-label="Fil d'Ariane">
        <ol className="flex flex-wrap items-center gap-1 text-sm text-gray-400">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;

            return (
              <li key={index} className="flex items-center gap-1">
                {index > 0 && <span className="text-gray-600" aria-hidden="true">&gt;</span>}
                {isLast ? (
                  <span className="text-safe font-medium" aria-current="page">
                    {item.label}
                  </span>
                ) : (
                  <Link
                    to={item.to}
                    className="text-gray-400 hover:text-safe transition-colors"
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </>
  );
}
